import React, { useEffect, useState } from "react";
import { FolderKanban } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { PageHeader, EmptyState, Loader } from "@/components/dashboard/ui";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useSelect, SelectCheck, SelectionToolbar } from "@/components/admin/BulkBar";

const PROJECT_STATUSES = ["Demande reçue", "À contacter", "Rendez-vous planifié", "Analyse en cours", "Proposition envoyée", "Acceptée", "En cours", "Terminée", "Refusée"];

export default function AdminProjects() {
  const [projects, setProjects] = useState(null);
  const [arch, setArch] = useState(false);
  const sel = useSelect();
  const load = () => api.get(`/requests?include_archived=${arch}`).then(({ data }) => setProjects((data || []).filter((r) => r.kind === "project")));
  useEffect(() => { sel.clear(); load(); /* eslint-disable-next-line */ }, [arch]);
  const setStatus = async (r, status) => {
    try { await api.put(`/requests/${r.request_id}`, { status }); toast.success("Statut mis à jour"); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  if (projects === null) return <Loader />;
  return (
    <div>
      <PageHeader title="Demandes de projet" subtitle="Accompagnements et projets sans créneau horaire." />
      <SelectionToolbar items={projects} idKey="request_id" sel={sel} entity="requests" onDone={load} label="projet" archived={arch} onToggleArchived={() => setArch((a) => !a)} />
      {projects.length === 0 ? <EmptyState icon={FolderKanban} title={arch ? "Aucun projet archivé" : "Aucun projet"} /> : (
        <div className="space-y-3">{projects.map((r) => (
          <div key={r.request_id} className={`relative bg-white rounded-xl border p-5 pl-11 flex flex-wrap items-start justify-between gap-3 ${sel.has(r.request_id) ? "border-primary ring-1 ring-primary/30" : "border-slate-200"}`} data-testid={`project-${r.request_id}`}>
            <SelectCheck className="absolute left-3 top-6" checked={sel.has(r.request_id)} onChange={() => sel.toggle(r.request_id)} testId={`select-project-${r.request_id}`} />
            <div className="min-w-0">
              <div className="flex items-center gap-2 flex-wrap"><span className="font-semibold text-slate-900">{r.client_name}</span><span className="text-sm text-slate-400">{r.client_practice}</span></div>
              <p className="text-sm text-slate-600 mt-1">{(r.services || []).join(", ")}</p>
              {r.description && <p className="text-sm text-slate-400 mt-1 italic">« {r.description} »</p>}
            </div>
            <Select value={r.status} onValueChange={(v) => setStatus(r, v)}><SelectTrigger className="w-56"><SelectValue /></SelectTrigger><SelectContent>{PROJECT_STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent></Select>
          </div>))}
        </div>
      )}
    </div>
  );
}
